import { createRouter, createWebHashHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth.js'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { public: true },
  },
  {
    path: '/',
    component: () => import('@/layouts/AdminLayout.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '数据大盘', icon: 'DataLine' },
      },
      {
        path: 'users',
        name: 'Users',
        component: () => import('@/views/user/index.vue'),
        meta: { title: '用户管理', icon: 'User' },
      },
      {
        path: 'users/:id',
        name: 'UserDetail',
        component: () => import('@/views/user/detail.vue'),
        meta: { title: '用户详情', hidden: true },
      },
      {
        path: 'rides',
        name: 'Rides',
        component: () => import('@/views/ride/index.vue'),
        meta: { title: '骑行数据', icon: 'Bicycle' },
      },
      {
        path: 'devices',
        name: 'Devices',
        component: () => import('@/views/device/index.vue'),
        meta: { title: '设备管理', icon: 'Cpu' },
      },
      {
        path: 'bluetooth-configs',
        name: 'BluetoothConfigs',
        component: () => import('@/views/device/bluetooth-config.vue'),
        meta: { title: '蓝牙配置', icon: 'Connection', hidden: true },
      },
      {
        path: 'faults',
        name: 'Faults',
        component: () => import('@/views/fault/index.vue'),
        meta: { title: '故障管理', icon: 'Warning' },
      },
      {
        path: 'system',
        name: 'System',
        meta: { title: '系统设置', icon: 'Setting' },
        children: [
          {
            path: 'admins',
            name: 'SystemAdmins',
            component: () => import('@/views/system/admin.vue'),
            meta: { title: '管理员账号', permission: 'super_admin' },
          },
          {
            path: 'logs',
            name: 'SystemLogs',
            component: () => import('@/views/system/logs.vue'),
            meta: { title: '审计日志', permission: 'super_admin' },
          },
        ],
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/profile/index.vue'),
        meta: { title: '个人中心', icon: 'Avatar', hidden: true },
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

// 路由守卫
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()

  // 公开页面直接放行
  if (to.meta.public) {
    next()
    return
  }

  // 未登录则跳登录页
  if (!authStore.isLoggedIn) {
    const restored = await authStore.restoreSession()
    if (!restored) {
      next('/login')
      return
    }
  }

  // 权限检查
  if (to.meta.permission === 'super_admin' && !authStore.isSuperAdmin) {
    next('/dashboard')
    return
  }

  next()
})

export default router
